var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "rgba(255,255,255,0)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12,11.293,22.293,1,23,1.707,12.707,12,23,22.293,22.293,23,12,12.707,1.707,23,1,22.293,11.293,12,1,1.707,1.707,1Z",
  transform: "translate(12 12)",
  fill: "#909090",
  fillRule: "evenodd"
})));
export default SvgIconClose;